import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useWatch } from 'react-hook-form';
import { AddressFields as GeneralAddressFields } from '../address-fields/AddressFields';
import { CountrySelector } from './CountrySelector';
import { Grid } from '@yonderland/andes-react';
export const AddressFields = ({ country, onCountryChange }) => {
    const invoiceEnabled = useWatch({ name: 'invoice' });
    const showAddressCard = ['NL', 'GB', 'GG', 'JE'].includes(country);
    return (_jsxs(_Fragment, { children: [_jsx(Grid, { columns: 2, gapX: 4, gapY: 6, children: _jsx(Grid.Cell, { span: { xs: 2, md: 1 }, children: _jsx(CountrySelector, { onCountryChange: onCountryChange }) }) }), _jsx(GeneralAddressFields, { prefix: "address.", country: country, isRequired: invoiceEnabled, showAddressCard: showAddressCard })] }));
};
